import { ISocial } from '@/types/social'

export const socials: ISocial[] = [
  {
    name: 'Twitter',
    href: 'https://x.com/pigmo_tech',
  },
  {
    name: 'Telegram',
    href: 'https://t.me/+7BVE4WUHpZMxMWQ0',
  },
  {
    name: 'Discord',
    href: 'https://discord.com/invite/pigmo',
  },
]
